import React, { ReactNode } from 'react';

import styles from './ResizableWrapper.css';
import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';

export const ResizableWrapper: React.FC<{ children: ReactNode }> = props => {
  return <GeneralInfoSectionRow className={styles['wrapper']}>{props.children}</GeneralInfoSectionRow>;
};

ResizableWrapper.displayName = 'ResizableWrapper';
